import {
  SVCheckbox,
  SVCurrencyInput,
  SVDateTimePicker,
} from '@/components/core';
import { Card, Grid, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type BankAccountEditFormControlsProps = {
  title: string;
  setLimitCheckboxName: string;
  limitName: string;
  expirationName: string;
};

export default function BankAccountEditFormControls({
  title,
  setLimitCheckboxName,
  limitName,
  expirationName,
}: BankAccountEditFormControlsProps) {
  const formMethods = useFormContext();
  const setLimit = formMethods.watch(setLimitCheckboxName);

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        {title} Controls
      </Typography>
      <SVCheckbox
        label={`Set ${title} Exception Limit`}
        name={setLimitCheckboxName}
      />
      {setLimit && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <SVCurrencyInput
              name={limitName}
              label={`${title} Exception Limit`}
              rules={{ required: true }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SVDateTimePicker
              captureInEstTz
              name={expirationName}
              label="Expiration Date and Time"
              rules={{ required: true }}
              dateFormat="MM/DD/YYYY h:mm A"
              disablePast
              includeSeconds
            />
            <Typography variant="body2">
              Program limit is set to expire based on EST timezone (UTC-04:00)
            </Typography>
          </Grid>
        </Grid>
      )}
    </Card>
  );
}
